import { render, staticRenderFns } from "./ModalRecallMe.vue?vue&type=template&id=763908f7&scoped=true"
import script from "./ModalRecallMe.vue?vue&type=script&lang=js"
export * from "./ModalRecallMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763908f7",
  null
  
)

export default component.exports